import type { IStorage } from './types';

export const SESSION_ITEMS: Array<keyof IStorage> = [
  'redirectedFromPrivate',
  'justLoggedOutEmail',
  'profile:consentInfo',
];
